import { useContext, useEffect, useState } from 'react';
import { SourceContext } from '../../../utils/sourceContext';
import { getCachedState, initUserState } from '../../../utils/stateContext';
import Header from '../../.shared/header/header';
import Footer from '../../.shared/footer/footer';
import Steps from '../../Landing/Steps';
import FeaturedIn from '../../Landing/FeaturedIn';
import Support from '../../Landing/Support';
import SuccessStories from '../../Landing/SuccessStories';
import OriginalHero from '../../Landing/OriginalHero';
import LegitScriptBanner from '../../.shared/LegitScriptBanner/LegitScriptBanner';
import PriceUpdateBanner from '../../Landing/PriceUpdateBanner/PriceUpdateBanner';

function GLP1VettedVendorLanding() {
    const { source, safeSource, switchAndSave } = useContext(SourceContext);
    const [userState, setUserState] = useState(getCachedState);
    const NON_SWITCH_AND_SAVE_STATES = (() => { try { return JSON.parse(process.env.REACT_APP_NON_SWITCH_AND_SAVE_STATES || '[]'); } catch { return []; } })();
    const stateBlocked = NON_SWITCH_AND_SAVE_STATES.length > 0 && NON_SWITCH_AND_SAVE_STATES.includes(userState);

    useEffect(() => {
        if (NON_SWITCH_AND_SAVE_STATES.length > 0) {
            initUserState().then(() => setUserState(getCachedState()));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!NON_SWITCH_AND_SAVE_STATES || NON_SWITCH_AND_SAVE_STATES.length === 0) {
        return (
            <>
                {switchAndSave && <PriceUpdateBanner />}
                <Header hideNavigation={source !== 'tb2'}/>
                <OriginalHero safeSource={safeSource} switchAndSaveSource={switchAndSave} showTB2VettedVendorSeal/>
                <FeaturedIn safeSource={safeSource} />
                <Steps switchAndSaveSource={switchAndSave} />
                <Support />
                <SuccessStories safeSource={safeSource} />
                <LegitScriptBanner />
                <Footer />
            </>
        );
    }

    if (userState === null) return null;

    return (
        <>
            {switchAndSave && !stateBlocked && <PriceUpdateBanner />}
            <Header hideNavigation={source !== 'tb2'}/>
            <OriginalHero safeSource={safeSource} switchAndSaveSource={switchAndSave && !stateBlocked} showTB2VettedVendorSeal />
            <FeaturedIn safeSource={safeSource} />
            <Steps switchAndSaveSource={switchAndSave && !stateBlocked} />
            <Support />
            <SuccessStories safeSource={safeSource} />
            <LegitScriptBanner />
            <Footer />
        </>
    );
}

export default GLP1VettedVendorLanding;
